import(/* webpackMode: "eager" */ "/codebuild/output/src2477779330/src/src/app/global-error.tsx");
